<template>
  <div :class="filaClass">
    <label :class="ui.colLeftClass">
      <slot name="label">{{ label }}</slot>
      <div v-if="ayuda" class="text-muted font-size-sm mt-1">{{ ayuda }}</div>
    </label>
    <div :class="ui.colRightClass">
      <slot></slot>
    </div>
  </div>
</template>

<script>
/**
 * Fila de pregunta de la ficha: etiqueta a la izquierda, control a la derecha,
 * con el resalte de completada/pendiente.
 *
 * Reproduce el markup que ya usaban las fichas anteriores (sheetRowQClass +
 * _sheet-question.scss) para que el aspecto no cambie.
 */
export default {
  name: "QFila",
  props: {
    label: { type: String, default: "" },
    ayuda: { type: String, default: "" },
    // false cuando la pregunta no corresponde a esta variante o su padre no la habilita
    aplica: { type: Boolean, default: true },
    completa: { type: Boolean, default: false },
    // false solo si la fila no debe mostrar el resalte verde/amarillo del cuestionario
    resaltar: { type: Boolean, default: true },
  },
  data() {
    return {
      ui: {
        colLeftClass: "col-12 col-md-5 col-form-label",
        colRightClass: "col-12 col-md-7",
      },
    };
  },
  computed: {
    filaClass() {
      if (!this.aplica || !this.resaltar) return ["form-group", "row"];
      return [
        "form-group",
        "row",
        "sheet-question",
        this.completa ? "sheet-question--completada" : "sheet-question--pendiente",
      ];
    },
  },
};
</script>
